// src/components/settingsComponents.jsx
import React from "react";

export function SettingsShell({ sidebar, children }) {
  return (
    <div className="st-shell">
      <aside className="st-sidebar">{sidebar}</aside>
      <main className="st-main">{children}</main>
    </div>
  );
}

export function SettingsSidebarCard({ title, children }) {
  return (
    <div className="st-sidebar-card">
      {title && <div className="st-sidebar-title">{title}</div>}
      {children}
    </div>
  );
}

export function SettingsHeader({ title, subtitle, action }) {
  return (
    <div className="st-header">
      <div>
        <h1 className="st-title">{title}</h1>
        {subtitle && <p className="st-subtitle">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function SettingsCard({ id, title, subtitle, danger = false, children }) {
  return (
    <section id={id} className={`st-card${danger ? " st-card--danger" : ""}`}>
      {(title || subtitle) && (
        <div className="st-card-head">
          {title && <h2>{title}</h2>}
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}
      {children}
    </section>
  );
}

export function SettingsField({ label, children }) {
  return (
    <div className="st-field">
      {label && <label>{label}</label>}
      {children}
    </div>
  );
}

export function SettingsToggle({ checked, onChange, children }) {
  return (
    <label className="st-toggle">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="st-toggle-ui" />
      <span className="st-toggle-copy">{children}</span>
    </label>
  );
}

export function SettingsEmptyState({ children }) {
  return <div className="st-empty">{children}</div>;
}

export function SettingsModal({ open, title, subtitle, onClose, children, actions }) {
  if (!open) return null;
  return (
    <div className="st-modal-backdrop" onClick={onClose}>
      <div className="st-modal" onClick={(e) => e.stopPropagation()}>
        <div className="st-modal-head">
          <h3>{title}</h3>
          <button type="button" className="st-modal-close" onClick={onClose}>×</button>
        </div>
        {subtitle && <p className="st-modal-subtitle">{subtitle}</p>}
        <div className="st-modal-body">{children}</div>
        {actions && <div className="st-modal-actions">{actions}</div>}
      </div>
    </div>
  );
}
